import { handleActions } from "redux-actions";
import {
  addConversion,
  updateStoreConversionStatus,
  removeAllConversion,
  updateStoreConversionStatusDescription,
} from "../actions/actions";

export default handleActions(
  {
    [addConversion]: (state, action) => {
      const updatedConversions = [...state, action.payload];
      return updatedConversions;
    },
    [updateStoreConversionStatus]: (state, action) => {
      for (let i = 0; i < state.length; i++) {
        if (state[i].id === action.payload.id) {
          if (
            state[i].status !== "Done" &&
            state[i].status !== "TimeOut" &&
            state[i].status !== "ko"
          )
            state[i].status = action.payload.status;
          break;
        }
      }
      const updatedConversions = [...state];
      return updatedConversions;
    },
    [updateStoreConversionStatusDescription]: (state, action) => {
      for (let i = 0; i < state.length; i++) {
        if (state[i].id === action.payload.id) {
          state[i].description = action.payload.description; //Alwayls copy description
          /*
          if (
            state[i].status !== "Done" &&
            state[i].status !== "TimeOut" &&
            state[i].status !== "ko"
          )
            state[i].description = action.payload.description;  */
          break;
        }
      }
      const updatedConversions = [...state];
      return updatedConversions;
    },
    [removeAllConversion]: (state, action) => {
      const updatedConversions = [];
      return updatedConversions;
    },
  },

  []
);
